var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['app-main']},[_c('wt-view',{class:_vm.$style['app-main__view']})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }